import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRDataRetriever} from "#Formulas/FormulaCore/Elements/FRField/FRDataRetriever";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {Sanitizer} from "#Formulas/FormulaCore/Sanitizer";
import {DateUtilities} from "#Formulas/FormulaCore/DateUtilities";


export class FRMain extends FRBase{
    public Sentences:FRBase[];
    private _retriever:FRDataRetriever;
    public ShouldReturn:boolean=false;
    constructor(Options: any,dataRetriever:FRDataRetriever) {
        super(Options, null);
        this.Sentences=[];
        this._retriever=dataRetriever;

        if(Array.isArray(Options?.d))
            Options.d.forEach(x=>{
                this.Sentences.push(FRFactory.GetFRElement(x,this));
            })

    }

    public get Retriever(){
        return this._retriever;
    }

    protected InternalParse(){
        let result=null;

        return this.Iterate(this.Sentences,(item,index,onEnd:()=>void)=>{
            result=item;
            if(this.ShouldReturn)
                onEnd();

        },()=>result)
        /*let iterate=(items,index)=>{
            if(items.length>index)
            {
                result=items[index].Parse();
                if(result instanceof Promise)
                {
                    return new Promise(async (resolve,reject)=>{
                        do{
                            if(result instanceof Promise)
                                result=await result;
                            if(this.ShouldReturn||index+1==items.length) {
                                resolve(result);
                                return;
                            }
                            index++;
                            result=items[index].Parse();

                        }while(true);
                    });
                }else{
                    if(this.ShouldReturn)
                        return result;
                    return iterate(items,index+1);
                }
            }else
                return result;
        }
        return iterate(this.Sentences,0);*/
    }


    ParsePrice(): any {
        return this.MaybeExecutePromise(this.Parse(),result=>{return Sanitizer.SanitizeNumber(result)});
    }

    ParseNumber(): any {
        return this.MaybeExecutePromise(this.Parse('Num'),result=>{return Sanitizer.SanitizeNumber(result)});
    }


    GetType(): string {
        return "Main";
    }

    public ReturnWasExecuted(){
        this.ShouldReturn=true;
    }




    Parse(type:'Num'|'Str'|null=null) {
        return this.MaybeExecutePromise(this.InternalParse(),result=>{
            if(result?.IsField) {
                if(Array.isArray(result))
                    (result as any[]).reduce((previousValue, currentValue) =>currentValue.GetNumber()+previousValue ,0);
                if(type=='Num')
                    return result.GetNumber();
                if(type=='Str')
                    return result.GetText();
                return result.GetPrice();
            }
            if(Array.isArray(result))
                return result.map(x=>Sanitizer.SanitizeString(x)).join(', ');

            if(result==null)
                return null;


            if(result instanceof Date)
                if(type=='Num')
                    return DateUtilities.DateToUnix(result);
                else
                    return result.toString();
            if(['boolean','string','number'].indexOf(typeof result)>=0)
                return result;

            return result.toString();
        });

    }

    ParseString() {
        return this.MaybeExecutePromise(this.Parse('Str'),result=>{return Sanitizer.SanitizeString(result)});
    }


    ParseRaw() {
        return this.InternalParse();
    }
}